import React from 'react';
import { Reveal } from './Reveal';
import { Button } from './Button';
export function CTASection() {
  return <section className="relative overflow-hidden border-t border-charcoal/[0.08] px-6 py-32 sm:px-10 sm:py-44" data-id="element-31" data-mp="27hovsaqxvse4">
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 left-1/2 h-[42rem] w-[42rem] -translate-x-1/2 rounded-full bg-champagne/20 blur-[120px] animate-drift-slow" data-id="element-32" data-mp="2ceyvcj81lkfo" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-33" data-mp="2mdek4fjlkhm0">
        <Reveal data-id="element-34" data-mp="2qeq3i3bvo6lr">
          <p className="eyebrow text-mocha" data-id="element-35" data-mp="2qe6whhnrn2mi">Let’s begin</p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-36" data-mp="2v5q1lbwqgupu">
          <h2 className="mt-7 font-serif text-[2.75rem] font-light leading-[1.02] tracking-[-0.01em] text-charcoal sm:text-[4.25rem]" data-id="element-37" data-mp="2v7jayyyqdt1j">
            Let’s build something meaningful.
          </h2>
        </Reveal>
        <Reveal delay={0.16} data-id="element-38" data-mp="3568ranazb5fo">
          <p className="mx-auto mt-8 max-w-lg text-base leading-relaxed text-charcoal/65" data-id="element-39" data-mp="3a3idlu32n0za">
            Whether you are building a company, deploying capital, or shaping a
            market — the work starts with a conversation.
          </p>
        </Reveal>
        <Reveal delay={0.24} data-id="element-40" data-mp="1w5ker1jt3vh5">
          <div className="mt-12 flex flex-wrap items-center justify-center gap-3" data-id="element-41" data-mp="1w9hy9oaaqp1k">
            <Button to="/contact" data-id="element-42" data-mp="1ra522cxjc5mb">Work together</Button>
            <Button to="/speaking" variant="secondary" data-id="element-43" data-mp="1n78sfbpz3jui">
              Book speaking
            </Button>
            <Button href="https://linkedin.com" variant="secondary" data-id="element-44" data-mp="2jvofn15m1h4g">
              Connect
            </Button>
          </div>
        </Reveal>
      </div>
    </section>;
}